import React from 'react';

interface InteractionListProps {
  songsPlayed?: string[];
  imagesViewed?: string[];
  eventsViewed?: string[];
  socialClicks?: Record<string, number>;
  streamingClicks?: Record<string, number>;
}

const cleanTitle = (t: string) => {
  const main = t.split(/\s*[-|]\s*/)[0].trim();
  return main.length > 40 ? main.slice(0, 40) + '…' : main;
};

const InteractionList: React.FC<InteractionListProps> = ({
  songsPlayed,
  imagesViewed,
  eventsViewed,
  socialClicks,
  streamingClicks,
}) => {
  const hasSongs = songsPlayed && songsPlayed.length > 0;
  const hasImages = imagesViewed && imagesViewed.length > 0;
  const hasEvents = eventsViewed && eventsViewed.length > 0;
  const hasSocial = socialClicks && Object.keys(socialClicks).length > 0;
  const hasStreaming = streamingClicks && Object.keys(streamingClicks).length > 0;

  if (!hasSongs && !hasImages && !hasEvents && !hasSocial && !hasStreaming) return null;

  const uniqueSongs = hasSongs ? [...new Set(songsPlayed.map(cleanTitle))] : [];

  return (
    <div className="flex flex-wrap gap-2">
      {hasSongs && (
        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-secondary text-secondary-foreground">
          Played {uniqueSongs.length} song{uniqueSongs.length !== 1 ? 's' : ''}
          {uniqueSongs.length <= 3 && `— ${uniqueSongs.join(', ')}`}
        </span>
      )}

      {hasImages && (
        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-secondary text-secondary-foreground">
          Viewed {imagesViewed.length} image{imagesViewed.length !== 1 ? 's' : ''}
        </span>
      )}

      {hasEvents && (
        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-secondary text-secondary-foreground">
          Viewed {eventsViewed.length} event{eventsViewed.length !== 1 ? 's' : ''}
        </span>
      )}

      {hasStreaming && Object.entries(streamingClicks).map(([platform, count]) => (
        <span key={platform} className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-secondary text-secondary-foreground">
          Clicked {platform} ({count} time{count !== 1 ? 's' : ''})
        </span>
      ))}

      {hasSocial && Object.entries(socialClicks).map(([platform, count]) => (
        <span key={platform} className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-secondary text-secondary-foreground">
          Clicked {platform} ({count} time{count !== 1 ? 's' : ''})
        </span>
      ))}
    </div>
  );
};

export default InteractionList;
